import {
  Box, Typography, Stack,
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { convertMoney } from '@/utils/convertMoney';
import Head from 'next/head';
import { style } from '@/styles/globals';
import { styled } from '@mui/system';
import { pr } from '@/utils/pxToRem';
import { lunarYear } from '@/utils/seoHelper';
import { ILangObj, MetaFAQ } from '@/slices/goyoloSeo/sliceType';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { templateStr } from '@/utils/templateStr';

const REG = /from_name|to_name|luna_year|route_now|latest_pickup_time|earliest_pickup_time|min_fare|route_airline|route_name|average_duration|company|min_price_time/gi;
interface FAQListVcmsProps {
  sxWrapper?: {
    [key: string]: any
  },
  idComponent: string | undefined,
  titleComponent?: string,
  metaJson: MetaFAQ,
  isDesktop?: boolean;
  heightDivider?: string
  params: any,
  block: any,
  lang: ILangObj;
  routeName: string;
}

const StyledDivider = styled<any>('div')`
  height: ${(props) => props.height || '8px'};
  background: ${style.color.white2};
  width: calc(100% + 32px);
  margin-left: -16px !important;
`;
const StyledDividerDesktop = styled('div')`
  height: 24px;
  background: ${style.color.white2};
  width: calc(100% + 48px);
  margin-left: -24px !important;
`;

export default function FAQListVcms(props: FAQListVcmsProps) {
  const {
    sxWrapper, idComponent, metaJson, params,
    isDesktop, heightDivider, block, lang, routeName,
  } = props;
  const titleComponent = block?.headingContent?.title;
  const replaceContent = (content: string) => content
    .replace(/({{|}})/g, '')
    .replace(REG, (x: string) => params[x] || '');

  return (
    <Stack>
      <Box
        sx={{
          ...sxWrapper,
        }}
        id={idComponent}
      >
        {!!metaJson && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(metaJson),
            }}
          />
        </Head>
        )}

        <Box
          sx={container}
        >
          {(metaJson.mainEntity || []).map((x, idx) => (
            <Accordion
              key={idx}
              id={`${idx}`}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography
                  component="h4"
                  variant="body1"
                >
                  {replaceContent(x.name)}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {!!x?.acceptedAnswer?.text && (
                  <Typography
                    component="div"
                    variant="body1"
                    dangerouslySetInnerHTML={{ __html: replaceContent(templateStr(x.acceptedAnswer.text, { airport: params?.airport })) }}
                  />
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Stack>

  );
}

const container = {
  padding: '16px 0px',
};
